export default __webpack_public_path__ + "static/media/left-arrow.0c55edf7.svg";